// extracted by mini-css-extract-plugin
export var divider = "_bg-0";
export var systemMessage = "_bg-1";
export var systemMessageWrapper = "_bg-2";